<template>
    <BlockConfig title="Tabella misure"
    :valid="isValid"
    @handleSave="getDataAndSave"
    :reduced="false"
    @restore="restoreDeep">
    <v-form v-model="valid">
        <div class="d-flex my-2">
            <v-text-field dense outlined
                label="nome prova*"
                :rules="[rules.mandatory]" 
                v-model="config_data.title"
            ></v-text-field>
        </div>
        <div class="text-h6">{{config_data.test.block.label}}</div>
        <test
        v-if="config_data.test"
        :data="config_data.test"
        ref="testBlock"
        />
        <div class="text-h6">{{config_data.linearity.block.label}}</div>
        <linearity
        v-if="config_data.linearity"
        :data="config_data.linearity"
        ref="linearityBlock"
        />
        <div>
            <v-label>Tutorial/Descrizione prova</v-label>
            <div class="d-flex mt-2 flex-wrap">
                <v-textarea dense outlined label="tutorial" placeholder="" v-model="config_data.tutorial_text" />
            </div>
        </div>
        <v-container class="ma-0 pa-0" v-if="!data.reduced">
            <v-row no-gutters >
                    <v-col cols="6" class="d-flex align-stretch">
                        <v-card class="elevation-2 mr-2 flex-grow-1 flex-shrink-0" >
                            <v-radio-group class="mx-4" v-model="config_data.zero_device">
                                <template v-slot:label>
                                    <div><span class="font-weight-bold">zero tracking </span><span class="caption">(valore di default)</span></div>
                                </template>
                                    <v-radio class="mx-2" value="on"><template v-slot:label>
                                        <div>acceso</div></template></v-radio>
                                    <v-radio class="mx-2" value="off"><template v-slot:label>
                                        <div>spento</div></template></v-radio>
                                    <v-radio class="mx-2" value="out"><template v-slot:label>
                                        <div>fuori zona intervento</div></template></v-radio>
                            </v-radio-group>
                        </v-card>
                    </v-col>
                    <v-col cols="6" class="d-flex align-stretch ">
                        <v-card class="ml-2 elevation-2 flex-grow-1 flex-shrink-0" >
                            <v-radio-group class="mx-4" v-model="config_data.hi_res">
                                <template v-slot:label>
                                    <div><span class="font-weight-bold">alta risoluzione </span><span class="caption">(valore di default)</span></div>
                                </template>
                                <v-radio class="mx-2" value="on"><template v-slot:label>
                                    <div>acceso</div></template></v-radio>
                                <v-radio class="mx-2" value="off"><template v-slot:label>
                                    <div>spento</div></template></v-radio>
                            </v-radio-group>
                        </v-card>
                    </v-col>
                </v-row>
        </v-container>
        <div>
            <div class="text-h6">{{config_data.repeatability.block.label}}</div>
            <rep
            v-if="config_data.repeatability"
            :data="config_data.repeatability"
            ref="repBlock"
            />
        </div>
    </v-form>
    </BlockConfig>
</template>
<script>
import test from "../nawi_zavorra.vue"
import linearity from "./nawi_linearity_zavorra.vue"
import rep from "../nawi_repeatability.vue"
import { f_rules } from '../../../../utils/commonUtils'
import {ConfigMixin} from '../../../../utils/configMixin_new'
import BlockConfig from '../../../../components/utils/BlockConfig'
export default {
    mixins: [ConfigMixin],
    components: {test, linearity, BlockConfig, rep},
    data(){
        return {
            rules: f_rules,
            valid: false,
            o_data: {
                title: this.data.block.label,
                zero_device: 'out',
                hi_res: 'on',
                test: null,
                linearity: null,
                repeatability: null
            }
        }
    },
    methods: {
        async getBlock(blockID){
            let res = await this.$store.state.$pouch.get('masters', blockID)
            return {block: res, idx: blockID, reduced: true}
        },
        getDataAndSave(){
            this.config_data.test.block.conf = this.$refs.testBlock.getData()
            this.config_data.linearity.block.conf = this.$refs.linearityBlock.getData()
            this.config_data.repeatability.block.conf = this.$refs.repBlock.getData()
            this.config_data.test.block.conf.hi_res = this.config_data.hi_res
            this.config_data.test.block.conf.zero_device = this.config_data.zero_device
            this.config_data.linearity.block.conf.hi_res = this.config_data.hi_res
            this.config_data.linearity.block.conf.zero_device = this.config_data.zero_device
            this.config_data.repeatability.block.conf.zero_device = this.config_data.zero_device
            this.config_data.repeatability.block.conf.hi_res = this.config_data.hi_res
            console.log("$$ config data before save", this.config_data)
            this.handleSave()
        },
        async initCustomData(){
            console.log("$$ test")
            let testBlock = await this.getBlock('baseblock:leg:nawi_zavorra:1')
            let linearityBlock = await this.getBlock('baseblock:leg:linearity_nawi_zavorra:1')
            let repBlock = await this.getBlock('baseblock:leg:repeatability_nawi_zavorra:1')
            this.o_data.test = testBlock
            this.o_data.linearity = linearityBlock
            this.o_data.repeatability = repBlock
            console.log("$$ building data", this.o_data)
        },
        restoreDeep(){
            this.restore()
            this.$refs.testBlock.restore()
            this.$refs.linearityBlock.restore()
        }
    },
    computed: {
        isValid(){
            if(this.valid && this.$refs.testBlock.getValid() && this.$refs.linearityBlock.getValid()){
                return true
            } else {
                return false
            }
        }
    }
}
</script>
